/*eslint-disable*/

import React from "react";
import "../css/Viva.css";
import { Link, Route, Switch } from "react-router-dom";

import Footer from "../components/Footer";

import value from "../images/value.png";

function Viva() {
  return (
    <div className="vivaContainer">
      <div id="lnb">
        <Link to="/company/1">회사소개</Link>
        <Link to="/company/2" className="on">
          비전&핵심가치
        </Link>
        <Link to="/company/3">연혁</Link>
      </div>

      <div className="subvision">
        <h2>VISION</h2>
        <p>
          (주)디아이솔루션은 데이터를 통한 새로운 가치를 창조하고 시장을
          선도합니다.
        </p>
      </div>
      <div className="submission">
        <h2>MISSION</h2>
        <p>
          (주)디아이솔루션은 데이터를 통한 새로운 가치를 창조하고 시장을
          선도합니다.
        </p>
        <p>
          (주)디아이솔루션은 데이터를 통한 새로운 가치를 창조하고 시장을
          선도합니다.
        </p>
        <p>
          (주)디아이솔루션은 데이터를 통한 새로운 가치를 창조하고 시장을
          선도합니다.
        </p>
      </div>
      <div className="subvalue">
        <h2>CORE VALUE</h2>
        <p>CREATIVE - INNOVATION - PARTNERSHIP</p>
        <img src={value} alt="corevalue" />
      </div>
      <Footer />
    </div>
  );
}

export default Viva;
